import { Directive, input, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appColumnTemplate]',
  standalone: true,
})
export class DataTableColumnTemplateDirective {
  key = input.required<string>({ alias: 'appColumnTemplate' });
  type = input<'cell' | 'footer'>('cell');
  templateRef = inject(TemplateRef);
}
